import SavingsQuote from './SavingsQuote'

export default SavingsQuote
